<template>
  <div class="order-confirm">
    <div class="page-title">选择地址</div>
    <div v-if="addressList.length" class="address-wrap">
      <div v-for="(item) in addressList" :key="item.id" @click="addressId = item.id" class="address">
        <div class="address-left">
          <div class="address-icon">
            <el-radio class="my-radio" :label="item.id" v-model="addressId">{{''}}</el-radio>
          </div>
          <div class="address-content">
            <div class="name-phone">{{item.consignee}} <span style="margin-left:15px;">{{item.telephone}}</span></div>
            <div class="address-detail">{{item.provinceName + item.cityName + item.areaName + item.detailAddress}}</div>
          </div>
        </div>
        <div class="address-right"  @click.stop="editAddress(item)" style="margin-right:5px;">
          <i class="el-icon-edit" style="font-size:20px;"></i>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      暂无地址
    </div>
    <div>
      <el-button type="primary" style="width:100%;margin-top:20px;" @click="confirm">确认</el-button>
    </div>
    <div>
     <el-button type="primary" style="width:100%;margin-top:20px;" @click="addAddress">新增地址</el-button>
    </div>
  </div>
</template>

<script>
import API from "../lib/API";
export default {
  name: 'OrderList',
  data() {
    return {
      addressId: '',
      addressList: []
    }
  },
  computed: {
    categoryDisabled() {
      if (this.dataType === '1' || (this.dataType === '2' && this.shopId)) {
        return false
      }
      return true
    }
  },
  methods: {
    confirm() {
      if (!this.addressId) {
        this.$message.error('请选择地址')
      }
      localStorage.setItem('selectAddressId', this.addressId)
      this.$router.back()
    },
    addAddress() {
      this.$router.push({name: 'AddressEdit'})
    },
    editAddress(item) {
      this.$router.push({name: 'AddressEdit', query: { id: item.id }})
    },
    getAddressList() {
      new API(this).POST({
        url: '/address/listWithPage',
        params: {
          count: true,
          pageNum: 1,
          pageSize: 100
        },
        cb: res => {
          this.addressList = res.result
          let defAddress = null
          let addressId = this.$route.query.addressId
          if (addressId) {
            defAddress = this.addressList.find(item => {
              return item.id == addressId
            })
          } else {
            defAddress = this.addressList.find(item => {
              return item.defAddress == 1
            })
          }
          defAddress && (this.addressId = defAddress.id)
        }
      })
    }
  },
  created() {
    let { num, total, code, ipImgUrl } = this.$route.query
    this.num = num
    this.total = total
    this.code = code
    this.ipImgUrl = ipImgUrl
    this.getAddressList()
  },

}
</script>
<style scoped lang="less">
.my-radio {
  transform: scale(1.4);
}
.no-data {
  font-size:20px;
  color:#222;
  text-align: center;
  line-height: 50px;
}
.address-wrap {
  max-height:480px;
  overflow: auto;
}
.order-confirm {
  width:400px;
  margin:0 auto;
  background:#f1f1f1;
  border-radius: 10px;
  padding:10px 30px 30px;
  .page-title {
    font-size:16px;
    font-weight: bold;
    height:50px;
    line-height: 50px;
    text-align: center;
    margin-bottom:10px;
  }
  .address {
    display: flex;
    justify-content: space-between;
    background:#fff;
    border-radius: 10px;
    margin-bottom:20px;
    padding:15px;
    align-items: center;
    cursor: pointer;
    &:last-child {
      margin-bottom:0;
    }
    .address-left {
      display: flex;
      align-items: center;
      .address-icon {
        font-size:30px;
        display: flex;
        align-items: center;
        margin-left:10px;
        justify-content: center;
      }
      .address-content {
        margin-left:10px;
        width:280px;
        .name-phone {
          font-size:16px;
          font-weight: bold;
          margin-bottom:10px;
        }
      }
    }
    .address-right:hover {
      color:#409EFF;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Address.vue